import MenuItem from '@material-ui/core/MenuItem';
import React, { useContext } from 'react';
import { AppContext } from '../AppContext';
import { AuthService } from '../../auth/Service';

export const WebAppSSO = ({ onClose }) => {
    const app = useContext(AppContext);
    const webAppUrl = app.settings?.urls?.web_app_url;
    if (!webAppUrl) return null;

    const handleClick = async () => {
        onClose();
        try {
            const { url } = await AuthService.fetchWebAppSSOCode();
            const dest = new URL(url || webAppUrl);
            dest.searchParams.set('sso_switch', '1');
            window.open(dest.toString(), '_blank', 'noopener,noreferrer');
        } catch (e) {
            window.open(webAppUrl, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <MenuItem style={{ width: '100%' }} onClick={handleClick}>
            Web App
        </MenuItem>
    );
};
